module.exports = __webpack_public_path__ + "img/banner2.df736a8d.png";